export const defaultConfig = {
	masonry: true,
	masonryMaxHeight: 200,
	masonryGutter: 4,
	loop: false,
	index: 0,
	backgroundOpacity: 0.85,
	counter: false,
	lightboxMaxHeight: "100%",
	lightboxMaxWidth: "100%",
	animationDuration: 100
}